import {
    request,
} from '../request.js'

// 所有企业
export function reqRecordList(data) {
    return request({
        url: '/web/back/sys/pay/list',
        method: 'post',
        data
    })
}

// 查询所有用户  /web/back/sys/user/getUserList  查询所有用户接口
export function reqGetUserList() {
    return request({
        url: '/web/back/sys/user/getUserList',
        method: 'get',

    })
}

// 获取用户  
export function reqGetUser(id) {
    return request({
        url:`/web/back/sys/user/${id}`,
        method: 'get',
    })
}